import caller from './Caller'

export const getAgentInformation = async (agentId) => {
    const { data } = await caller({
        method: 'GET',
        url: `/Properties/GetAgentInformation?agentId=${agentId}`
    })

    return data
}

export const getAgents = async () => {
    const { data } = await caller({
        method: 'GET',
        url: '/Properties/GetAgents'
    })

    return data
}
